var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.324,
    height: 25.514,
    viewBox: "0 0 22.324 25.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#770303;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.97,20.73h-1.2a.6.6,0,0,1-.6-.6V9.368a.6.6,0,0,1,.6-.6h1.2a.6.6,0,0,1,.6.6V20.132A.6.6,0,0,1,8.97,20.73ZM.8,3.987H4.9L6.6,1.161A2.392,2.392,0,0,1,8.65,0h5.024a2.392,2.392,0,0,1,2.051,1.161l1.7,2.825h4.107a.8.8,0,0,1,.8.8v.8a.8.8,0,0,1-.8.8h-.8V23.122a2.392,2.392,0,0,1-2.392,2.392H3.987a2.392,2.392,0,0,1-2.392-2.392V6.378H.8a.8.8,0,0,1-.8-.8v-.8A.8.8,0,0,1,.8,3.987Zm12.964-1.45a.3.3,0,0,0-.257-.145H8.82a.3.3,0,0,0-.257.145l-.87,1.45h6.938ZM3.987,23.122H18.338V6.378H3.987ZM14.551,20.73h-1.2a.6.6,0,0,1-.6-.6V9.368a.6.6,0,0,1,.6-.6h1.2a.6.6,0,0,1,.6.6V20.132A.6.6,0,0,1,14.551,20.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.5076a75e0cc3ce3b48d588e0f6c74a65.svg";
export { ForwardRef as ReactComponent };